<template>
	<div style='width: 100%'>
		<div class="agenda-card-wrapper px-4 py-4 mb-4">
			<div class="agenda-card-date">
				{{ formatDateRange(agendaEvent.events_agenda_from, agendaEvent.events_agenda_to) }}
			</div>
			<div class="agenda-card-description">
				{{ agendaEvent.events_agenda_text }}
			</div>
			<div
				v-for="{ track_color, track_id, track_name } in agendaEvent.tracks"
				:key="track_id"
				class="agenda-card-tag"
				:style="`color: ${track_color}`"
			>
				<v-icon :color="track_color" dark small class="mr-1"> mdi-circle</v-icon>
				{{ track_name }}
			</div>
			<div class="agenda-card-location" v-if="agendaEvent.session_location">
				<v-icon x-small> mdi-map-marker</v-icon>
				{{ agendaEvent.session_location }}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

export default {
	name: 'AgendaCard',

	props: {
		agendaEvent: {
			type: Object,
			default: () => {},
		},
	},

	methods: {
		formatDateRange(dateFrom, dateTo) {
			const options = {
				weekday: 'long',
				hour: '2-digit',
				minute: '2-digit',
				hour12: true,
			}

			//Convert Unix timestamps to JavaScript Date objects
			const fromDate = new Date(dateFrom * 1000)
			const toDate = new Date(dateTo * 1000)

			// Format the dates
			const formattedFromDate = fromDate.toLocaleString('en-US', options)
			const formattedToDate = toDate.toLocaleTimeString('en-US', options)

			// Construct the formatted date range string
			return `${formattedFromDate} - ${formattedToDate}`
		},
	},
}
</script>

<style lang="scss">
.agenda-card {
	&-wrapper {
		background: rgb(251, 251, 251);
		border: 1px solid rgb(226, 226, 226);
		border-radius: 12px;
	}

	&-date {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: bold;
	}

	&-description {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: normal;
		line-height: 20px;
	}

	&-tag {
		color: rgb(106, 167, 80);
		font-size: 13px;
		font-family: Montserrat;
		font-weight: bold;
	}

	&-location {
		display: flex;
		color: rgb(153, 153, 153);
		font-size: 13px;
		font-family: Montserrat;
		font-weight: 600;
		line-height: 17px;

		i {
			color: rgb(153, 153, 153) !important;
		}
	}
}
</style>
